<template>
  <div class="animated fadeIn">
    <PurchaseUpdate :providerId="providerId" />
  </div>
</template>
<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import PurchaseUpdate from '@/components/purchase/PurchaseUpdate.vue';
@Component({
  components: {
    PurchaseUpdate
  }
})
export default class PurchaseEdit extends Vue {
  private providerId!: string;
  private created() {
      this.providerId = this.$route.params.id;
  }
}
</script>
